import React, { useState } from "react";
import { FaCamera } from "react-icons/fa";
import "../Styles/ProfileImageUploader.css";

const POProfileImageUploader = ({ userId, profileImage, profileName, operationType }) => {
  return (
    <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "row", overflow: "hidden"}}>
      <div
        className="po-profile-overlay"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "20%",
          marginLeft: 0, 
        }}
      >
        <img
          src={profileImage}
          alt="Profile"
          className="po-profile-photo"
          style={{
            width: 200,
            height: 200,
            borderRadius: "50%",
            border: "4px solid white",
            objectFit: "cover"
          }}
        />
        <div
          className="hover-info"
          style={{
            position: 'absolute',
            top: 150,
            left: 150,
            width: 200,
            height: 200,
            borderRadius: '50%',
            backgroundColor: "black",
            color: 'white',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            opacity: 0,
            transition: 'opacity 0.3s',
          }}
        >
          <div style={{color: "white", background: "black"}}>UserId: {userId}</div>
          <div style={{color: "white", background: "black"}}>profileName: {profileName}</div>
        </div>
        </div>
    <div className= "up-profile-header-format" style={{ marginLeft: "2rem" }}>
      {operationType === 'post' && (
        <h1 className="up-format-h1" style={{ fontSize: 60 }}>
          Create Post
        </h1>
      )}

      {operationType === 'blogging' && (
        <h1 className="up-format-h1" style={{ fontSize: 60 }}>
          Micro Blogging
        </h1>
      )}

      {operationType === 'admirer' && (
        <h1 className="up-format-h1" style={{ fontSize: 60 }}>
          Admirers
        </h1>
      )}

      {operationType === 'group' && (
        <h1 className="up-format-h1" style={{ fontSize: 60 }}>
          Groups
        </h1>
      )}

      {operationType === 'explore' && (
        <h1 className="up-format-h1" style={{ fontSize: 60 }}>
          Explore
        </h1>
      )}

      {operationType === 'reels' && (
        <h1 className="up-format-h1" style={{ fontSize: 60 }}>
          Reels or Shorts 
        </h1>
      )}

      {operationType === 'collaboration' && (
        <h1 className="up-format-h1" style={{ fontSize: 60 }}>
          Collaboration
        </h1>
      )}

    </div>
    <div className="up-profile-more-format" style={{ marginLeft: 30}}> </div>
    </div>
  );
};

export default POProfileImageUploader;
